import PropTypes from 'prop-types';
import React from 'react';

export const MarketOrderWrapper = ({ Component }) => {
  const details = {
    tacticName: 'MARKET_ORDER',
    category: 'Entry',
    type: 'Market Order',
    domain: 'Underlying',
  };
  return <Component  details={details} />;
};

MarketOrderWrapper.propTypes = {
  Component: PropTypes.any
};


